import { HttpClient, HttpParams } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { eps } from './url.service'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class EmployeeResignationService {
  private http = inject(HttpClient) // Use inject() instead of constructor injection
  private api = eps.user

  list(userId: string): Observable<{ totalCount: number; empResignations: any[] }> {
    let params = new HttpParams()
    if (userId) {
      params = params.set('userId', userId)
    }
    // params = params.set('title', search)
    // params = params.set('page', page)
    // params = params.set('limit', limit)
    return this.http.get<{ totalCount: number; empResignations: any[] }>(
      this.api.empResignationApi,
      {
        params
      }
    )
  }

  create(offBoardForm: any): Observable<any> {
    return this.http.post<any>(this.api.empResignationApi, offBoardForm)
  }

  update(id: string, offBoardForm: any): Observable<any> {
    return this.http.put<any>(`${this.api.empResignationApi}/${id}`, { ...offBoardForm })
  }

  //   delete(id: string): Observable<Holiday> {
  //     return this.http.delete<Holiday>(`${this.api.holidaysApi}/${id}`)
  //   }
}
